import type { Member } from '@tribeplatform/gql-client/types'
import { GridList } from '@tribeplatform/react-ui-kit/Layout'

import type { StaticField, View } from '../../Views/types'
import { getColumns } from '../utils/utils'
import { MembersGalleryItem } from './MembersGalleryItem'

interface Props {
  members: Member[]
  fields: StaticField[]
  gallerySize: View['gallerySize']
  activeFieldId?: string
  showMoreButton: JSX.Element
}
export const MembersGallery = ({
  members,
  fields,
  gallerySize = 'medium',
  activeFieldId,
  showMoreButton,
}: Props) => {
  const columns = getColumns(gallerySize)

  return (
    <>
      <GridList columns={columns}>
        {members.map(member => (
          <MembersGalleryItem
            key={member.id}
            member={member}
            fields={fields.filter(
              field =>
                field.enabled &&
                !(field.styles && field.styles.indexOf('gallery') === -1),
            )}
            activeFieldId={activeFieldId}
          />
        ))}
      </GridList>
      {!!showMoreButton && <div className="mt-2">{showMoreButton}</div>}
    </>
  )
}
